(() => {
  'use strict';

  if (customElements.get('photo-gallery')) {
    return;
  }

  class PhotoGallery extends HTMLElement {
    connectedCallback() {
      this.items = this.getItems();
      this.triggers = this.querySelectorAll('[data-gallery-trigger]');

      if (!this.items.length || !this.triggers.length) {
        return;
      }

      this.onClick = this.onClick.bind(this);
      this.triggers.forEach((trigger) => trigger.addEventListener('click', this.onClick));
    }

    disconnectedCallback() {
      if (!this.triggers?.length || !this.onClick) {
        return;
      }

      this.triggers.forEach((trigger) => trigger.removeEventListener('click', this.onClick));
    }

    getItems() {
      const dataNode = this.querySelector('[data-gallery-items]');

      if (!dataNode) {
        return [];
      }

      try {
        const items = JSON.parse(dataNode.textContent);
        return Array.isArray(items) ? items : [];
      } catch (error) {
        console.error('Photo gallery items could not be parsed.', error);
        return [];
      }
    }

    onClick(event) {
      event.preventDefault();

      const trigger = event.currentTarget;
      const index = Number(trigger.getAttribute('data-gallery-index')) || 0;
      const mainClass = this.items.length === 1 ? 'pswp-zoom-gallery pswp-zoom-gallery--single' : 'pswp-zoom-gallery';
      const popupRoot = document.querySelector('.pswp[data-index="0"]');

      if (typeof window.theme?.LoadPhotoswipe !== 'function') {
        return;
      }

      this.resetPopupState(popupRoot);
      window.theme.a11y.state.trigger = trigger;

      new window.theme.LoadPhotoswipe(this.items, {
        barsSize: { top: 60, bottom: 60 },
        history: false,
        focus: false,
        index,
        mainClass,
        showHideOpacity: true,
        showAnimationDuration: 250,
        hideAnimationDuration: 250,
        closeOnScroll: false,
        closeOnVerticalDrag: false,
        captionEl: this.items.some((item) => item.title),
        closeEl: true,
        closeElClasses: ['caption-close'],
        tapToClose: false,
        clickToCloseNonZoomable: false,
        maxSpreadZoom: 2,
        loop: true,
        spacing: 0,
        allowPanToNext: true,
        pinchToClose: false
      }, 0, trigger);
    }

    resetPopupState(popupRoot) {
      if (!popupRoot) {
        return;
      }

      popupRoot.classList.remove('pswp--custom-loader');
      popupRoot.setAttribute('data-pswp-option-classes', '');

      const loader = popupRoot.querySelector('.pswp__loader');
      if (loader) {
        loader.remove();
      }

      const thumbs = popupRoot.querySelector('.pswp__thumbs');
      if (thumbs) {
        thumbs.innerHTML = '';
      }
    }
  }

  customElements.define('photo-gallery', PhotoGallery);
})();
